import React from 'react'

import { Fixed } from '../helpers/Position'
import Panel from './Panel'
import Separator from '../helpers/Separator'

const MFooter = ({ children, weight }) => (
  <div>
    <Fixed bottom={0} right={0} left={0}>
      <Panel noMargin noRadius>
        {children}
      </Panel>
    </Fixed>
    <Separator weight={weight || 0} />
  </div>
)

export default MFooter
